import { HisUploadFile } from '../model/his-upload-file';

export class HisFileUtil {

    /**
     * Removes the file from the files array
     *
     * @param files the files array
     * @param file the file to remove
     * @return an array of files
     */
    public static removeFile(files: File[], file: File): File[] {
        for(let aFile of files) {
            //console.log('removeFile #uploadFile', uploadFile);

            if(aFile === file) {
                console.log('removeFile #file #foundFile', file);
                let index = files.indexOf(aFile);
                if (index !== -1) {
                    files.splice(index, 1);
                    return files;
                }
            }
        }
        return files;
    }

    public static removeHisUploadFile(files: File[], hisUploadFile: HisUploadFile): File[] {
        for(let file of files) {
            //console.log('removeFile #uploadFile', uploadFile);

            if(file.name === hisUploadFile.name && file.type === hisUploadFile.contentType) {
                console.log('removeFile #file #foundFile', hisUploadFile);
                let index = files.indexOf(file);
                if (index !== -1) {
                    files.splice(index, 1);
                    return files;
                }
            }
        }
        return files;
    }


}
